import { string, null as zNull } from "zod";

export const conciergePresent = { input: string(), output: zNull() };
